import { render } from "./GroupRow.vue?vue&type=template&id=5a8b7a44&scoped=true"
import script from "./GroupRow.vue?vue&type=script&lang=js"
export * from "./GroupRow.vue?vue&type=script&lang=js"

import "./GroupRow.vue?vue&type=style&index=0&id=5a8b7a44&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8b7a44"]])

export default __exports__